import { useContext, useState } from 'react';
import l from '../../../../../lang';
import { commons } from '../../../../../utils/validations';
import Message from '../../../../common/message';
import { Button } from '../../../../common/button';
import { InvitationActionType, InvitationContext } from '../invitation-context';

interface DialogInviteStep1Props {
  onNext: () => void;
}

const DialogInviteStep1 = ({ onNext }: DialogInviteStep1Props) => {
  const { state, dispatch } = useContext(InvitationContext);
  const [email, setEmail] = useState(state.email || '');
  const [fullName, setFullName] = useState(state.fullName || '');
  const [emailFocused, setEmailFocused] = useState(false);
  const [nameFocused, setNameFocused] = useState(false);
  const [errors, setErrors] = useState<{ email?: string; fullName?: string }>({});

  const validateForm = (): boolean => {
    const newErrors: { email?: string; fullName?: string } = {};

    // Validar email
    if (!email.trim()) {
      newErrors.email = l('userManagement.emailRequired');
    } else if (!commons.emailValid(email)) {
      newErrors.email = l('userManagement.emailInvalid');
    }

    // Validar nombre y apellido
    if (!fullName.trim()) {
      newErrors.fullName = l('userManagement.fullNameRequired');
    } else if (!/^[A-Za-zÀ-ÿ0-9'\-+ ]{2,}( [A-Za-zÀ-ÿ0-9'\-+]{2,})+$/.test(fullName.trim())) {
      newErrors.fullName = l('userManagement.fullNameFormat');
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleAssignRole = () => {
    if (validateForm()) {
      dispatch({ type: InvitationActionType.SET_FULL_NAME, payload: { fullName } });
      dispatch({ type: InvitationActionType.SET_EMAIL, payload: { email } });
      onNext();
    }
  };

  return (
    <div className="dialog-invite">
      {Object.keys(errors).length > 0 && (
        <div className="dialog-invite__error-container">
          <Message
            type="error"
            body={
              <ul className="dialog-invite__error-list">
                {errors.email && <li>{errors.email}</li>}
                {errors.fullName && <li>{errors.fullName}</li>}
              </ul>
            }
          />
        </div>
      )}
      <div className="dialog-invite__subtitle">{l('userManagement.inviteSubtitle')}</div>
      <div className="dialog-invite__divider" />
      <div className="dialog-invite__content">
        <div className="dialog-invite__field">
          <label className="dialog-invite__label">{l('userManagement.emailLabel')}</label>
          <input
            type="email"
            className={`dialog-invite__input ${errors.email ? 'dialog-invite__input--error' : ''}`}
            placeholder={!emailFocused && !email ? 'email@example.com' : ''}
            value={email}
            onChange={e => setEmail(e.target.value)}
            onFocus={() => setEmailFocused(true)}
            onBlur={() => setEmailFocused(!!email)}
          />
          <p className="dialog-invite__helper-text">{l('userManagement.emailHelper')}</p>
        </div>

        <div className="dialog-invite__field">
          <label className="dialog-invite__label">{l('userManagement.fullNameLabel')}</label>
          <input
            type="text"
            className={`dialog-invite__input ${errors.fullName ? 'dialog-invite__input--error' : ''}`}
            placeholder={!nameFocused && !fullName ? 'Nombre Apellido' : ''}
            value={fullName}
            onChange={e => setFullName(e.target.value)}
            onFocus={() => setNameFocused(true)}
            onBlur={() => setNameFocused(!!fullName)}
          />
        </div>
      </div>

      <div className="dialog-invite__footer">
        <Button variant="contained" color="primary" onClick={handleAssignRole} className="dialog-invite__button">
          {l('userManagement.assignRole')}
        </Button>
      </div>
    </div>
  );
};

export default DialogInviteStep1;
